export default __webpack_public_path__ + "static/media/bg-subscribe.073d5af8.png";